var _defs, _path, _path2, _path3, _rect, _rect2, _path4, _path5, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Welding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aebCRXzVx9hguwWRv9gTTa",
    x1: 22.637,
    x2: 25.441,
    y1: 8.651,
    y2: 39.955,
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 120",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd869"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fec52b"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#64717c",
    d: "M47,18V30a2.00591,2.00591,0,0,1-2,2H26.97A2.15627,2.15627,0,0,1,26,33.41992,3.0151,3.0151,0,0,1,25,33.86a3.64118,3.64118,0,0,1-2,0,3.0151,3.0151,0,0,1-1-.44007A2.15627,2.15627,0,0,1,21.03,32H3a2.00591,2.00591,0,0,1-2-2V18a2.00583,2.00583,0,0,1,2-2H21a2.06325,2.06325,0,0,1,1-1.67993A3.48854,3.48854,0,0,1,23,13.88a3.91115,3.91115,0,0,1,2,0,3.48854,3.48854,0,0,1,1,.44007A2.06325,2.06325,0,0,1,27,16H45A2.00583,2.00583,0,0,1,47,18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#889097",
    d: "M27,16V32h-.03A2.15627,2.15627,0,0,1,26,33.41992,3.0151,3.0151,0,0,1,25,33.86a3.64118,3.64118,0,0,1-2,0,3.0151,3.0151,0,0,1-1-.44007A2.15627,2.15627,0,0,1,21.03,32H21V16a2.06325,2.06325,0,0,1,1-1.67993A3.48854,3.48854,0,0,1,23,13.88a3.91115,3.91115,0,0,1,2,0,3.48854,3.48854,0,0,1,1,.44007A2.06325,2.06325,0,0,1,27,16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#aebCRXzVx9hguwWRv9gTTa)",
    d: "M25,13.88V33.86a3.64118,3.64118,0,0,1-2,0V13.88a3.91115,3.91115,0,0,1,2,0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 20,
    x: 6,
    y: 14,
    fill: "#889097",
    rx: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 20,
    x: 36,
    y: 14,
    fill: "#889097",
    rx: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5,16V32H6V16Zm7,0V32h1V16Z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5,16V32H6V16ZM12,16V32h.5V16Z",
    opacity: 0.07
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42,16V32h1V16Zm-7,0V32h1V16Z",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42,16V32h.5V16ZM35.5,32H36V16h-.5Z",
    opacity: 0.07
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Welding);
export default __webpack_public_path__ + "static/media/icons8-welding.8f7580dd4abebaf229d55b5368010eb8.svg";
export { ForwardRef as ReactComponent };